/**
 * 温和反调试工具 - 只检测F12和开发者工具
 * 不影响正常的右键菜单和移动端操作
 */

// 检测是否为移动端
function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
         window.innerWidth <= 768 ||
         'ontouchstart' in window;
}

// 检测F12按键（仅桌面端）
function detectF12(event: KeyboardEvent) {
  // 移动端不检测键盘事件
  if (isMobile()) {
    return;
  }
  
  // F12键
  if (event.keyCode === 123) {
    crashPage();
    return false;
  }
  
  // Ctrl+Shift+I (开发者工具)
  if (event.ctrlKey && event.shiftKey && event.keyCode === 73) {
    crashPage();
    return false;
  }
  
  // Ctrl+Shift+J (控制台)
  if (event.ctrlKey && event.shiftKey && event.keyCode === 74) {
    crashPage();
    return false;
  }
  
  // Ctrl+U (查看源代码)
  if (event.ctrlKey && event.keyCode === 85) {
    crashPage();
    return false;
  }
  
  // Ctrl+Shift+C (检查元素)
  if (event.ctrlKey && event.shiftKey && event.keyCode === 67) {
    crashPage();
    return false;
  }
}

// 让页面崩溃
function crashPage() {
  // 温和的崩溃方式：重定向到空白页
  window.location.href = 'about:blank';
}

// 检测开发者工具是否打开
function detectDevTools() {
  // 移动端不检测窗口大小变化，因为移动端窗口大小检测不准确
  if (!isMobile()) {
    const threshold = 160;
    
    // 检测窗口大小变化（仅桌面端）
    const widthThreshold = window.outerWidth - window.innerWidth > threshold;
    const heightThreshold = window.outerHeight - window.innerHeight > threshold;
    
    if (widthThreshold || heightThreshold) {
      return true;
    }
  }
  
  // 检测控制台是否打开（移动端更宽松）
  if (!isMobile()) {
    let devtools = false;
    const element = new Image();
    Object.defineProperty(element, 'id', {
      get: function() {
        devtools = true;
        crashPage();
      }
    });
    
    console.log(element);
    console.clear();
    
    return devtools;
  }
  
  return false;
}

// 检测调试器（仅桌面端）
function detectDebugger() {
  // 移动端不检测调试器，避免误判
  if (isMobile()) {
    return;
  }
  
  setInterval(() => {
    const start = performance.now();
    debugger;
    const end = performance.now();
    
    if (end - start > 100) {
      crashPage();
    }
  }, 1000);
}

// 禁用文本选择（可选）
function disableTextSelection() {
  // 只禁用部分文本选择，保留输入框的正常选择
  const style = document.createElement('style');
  style.innerHTML = `
    body {
      -webkit-user-select: none !important;
      -moz-user-select: none !important;
      -ms-user-select: none !important;
      user-select: none !important;
    }
    
    input, textarea, [contenteditable] {
      -webkit-user-select: text !important;
      -moz-user-select: text !important;
      -ms-user-select: text !important;
      user-select: text !important;
    }
  `;
  document.head.appendChild(style);
}

// 初始化温和反调试
export function initGentleAntiDebug() {
  // 检测F12和快捷键（仅桌面端）
  document.addEventListener('keydown', detectF12);
  
  // 检测调试器
  detectDebugger();
  
  // 可选：禁用文本选择
  // disableTextSelection();
  
  // 定期检测开发者工具
  setInterval(() => {
    if (detectDevTools()) {
      crashPage();
    }
  }, 2000); // 降低检测频率，减少性能影响
  
  const deviceType = isMobile() ? '移动端' : '桌面端';
  console.log(`🛡️ 温和反调试保护已启用 (${deviceType}) - 只检测F12和开发者工具`);
}

// 导出崩溃函数
export { crashPage };
